import { ImageProps } from './component';

export interface ImageRendererExtraProps {}

export type ImageRendererProps = ImageProps & ImageRendererExtraProps;
